import { useState } from 'react';
import { apiDownload } from '../../api/client';

const MONTHS = [
  'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
  'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık',
];

export default function AdminExport() {
  const now = new Date();
  const [year, setYear] = useState(now.getFullYear());
  const [month, setMonth] = useState(now.getMonth() + 1);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const years = Array.from({ length: 6 }, (_, i) => now.getFullYear() - i);

  async function onDownload() {
    setBusy(true);
    setErr(null);
    try {
      const ym = `${year}-${String(month).padStart(2, '0')}`;
      await apiDownload(
        `/api/admin/export?year=${year}&month=${month}`,
        `fis-raporu-${ym}.xlsx`,
      );
    } catch (e) {
      setErr((e as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="max-w-xl">
      <h1 className="text-2xl font-bold mb-4">Aylık Excel Raporu</h1>
      <div className="card p-6 space-y-4">
        <p className="text-sm text-slate-600">
          Seçilen ay için tüm kullanıcıların fişlerini tek sayfada (Monthly Report) Excel dosyası olarak indirin.
        </p>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="label">Yıl</label>
            <select className="input" value={year} onChange={(e) => setYear(Number(e.target.value))}>
              {years.map((y) => (
                <option key={y} value={y}>{y}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="label">Ay</label>
            <select className="input" value={month} onChange={(e) => setMonth(Number(e.target.value))}>
              {MONTHS.map((m, i) => (
                <option key={i} value={i + 1}>{m}</option>
              ))}
            </select>
          </div>
        </div>
        {err && <div className="text-sm text-red-600">{err}</div>}
        <button className="btn-primary w-full" disabled={busy} onClick={onDownload}>
          {busy ? 'Hazırlanıyor…' : 'Excel İndir'}
        </button>
      </div>
    </div>
  );
}
